/**
 * Prefixed logger for the SPA navigation engine.
 *
 * Every console call in navigate/ goes through this helper so the
 * prefix stays consistent and so log sites can be muted as a group
 * if the need arises. The implementation is deliberately minimal -
 * no log levels, no buffering, no dynamic enable flag - because
 * the goal is consistency, not a fully-featured logger.
 */

const PREFIX = '[SDX Navigate]';

export const logger = {
  info(message: string, ...rest: unknown[]): void {
    console.info(`${PREFIX} ${message}`, ...rest);
  },
  warn(message: string, ...rest: unknown[]): void {
    console.warn(`${PREFIX} ${message}`, ...rest);
  },
  error(message: string, ...rest: unknown[]): void {
    console.error(`${PREFIX} ${message}`, ...rest);
  },
};
